import {useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import {api} from '../lib/api.js';

export default function ImportedRoadRoutes({base,importId,canRetry=true}){
  const [routes,setRoutes]=useState(null),[error,setError]=useState(null),[retrying,setRetrying]=useState(false);
  useEffect(()=>{
    let live=true;let timer;
    const refresh=async()=>{
      if(document.hidden){timer=setTimeout(refresh,3000);return;}
      try{const r=await api(`${base}/imports/${importId}/road-routes`);if(live){setRoutes(r.routes);setError(null);if(r.routes.some((j)=>['pending','processing'].includes(j.status)))timer=setTimeout(refresh,3000);}}
      catch(e){if(live){setError(e.message);timer=setTimeout(refresh,10000);}}
    };
    refresh();return()=>{live=false;clearTimeout(timer);};
  },[base,importId,retrying]);
  return <section aria-label="Automatic truck routes">
    <h3>Automatic truck routes</h3>
    <p>Road paths are system estimates from the truck-routing provider. Travel times exclude live traffic.</p>
    {error&&<p role="alert">{error}</p>}
    {!routes?<p>Checking route generation…</p>:!routes.length?<p>No automatic routes queued for this import.</p>:<ul className="route-list">{routes.map((r)=><li key={r.id}>
      <strong>{r.name}</strong> · {r.status==='ready'?'Ready':r.status==='failed'?'Routing failed':r.status==='processing'?'Generating road path…':'Queued for routing'}
      {r.error&&<p className="muted">{r.error}</p>}
      {r.status==='ready'&&<><p>{r.distance_m!=null?`${(r.distance_m/1000).toFixed(1)} km`:''}{r.duration_s!=null?` · approximately ${Math.round(r.duration_s/60)} minutes`:''}</p><Link className="btn" to={`/?route=${r.route_id}`}>View route on map</Link></>}
    </li>)}</ul>}
    {canRetry&&routes?.some((r)=>r.status==='failed')&&<button className="btn" disabled={retrying} onClick={async()=>{setRetrying(true);try{await api(`${base}/imports/${importId}/road-routes/retry`,{method:'POST',body:{}});}catch(e){setError(e.message);}finally{setRetrying(false);}}}>Retry failed routes</button>}
  </section>;
}
